import { usePageTitle } from "../../../../../shared/hooks/usePageTitle";
import { useTranslation } from "../../i18n/useTranslation";

/**
 * THE TITLE OF EVERY BOOKING OUTCOME PAGE (Founder, 2026-10-06):
 * "Booking details · <business> · Lura", or "Booking details · Lura" when the
 * business name is unavailable. ES "Detalles de la cita".
 *
 * One title for the confirmed, requested, uncertain and unknown outcomes
 * alike, and never the outcome itself: a title outlives the page in tab
 * strips, history and bookmarks, and an outcome can still change. It says
 * nothing about whether anything was booked or confirmed.
 *
 * `business` is a PUBLIC name only: the committed receipt's when the outcome
 * carries one, otherwise the profile's. Nothing about the client.
 */
export function useOutcomeTitle(business: string | null | undefined): void {
  const { t } = useTranslation();
  usePageTitle(t("flow.outcome.pageTitle"), business);
}

/** The same title, for an outcome drawn inline rather than as a component. */
export function OutcomeTitle({ business }: { business: string | null | undefined }): null {
  useOutcomeTitle(business);
  return null;
}
